import styled from "styled-components"

import theme from "../../../theme/"
import { Link } from "gatsby"

export const Footer = styled.footer`
  display: inline-flex;
  flex-direction: column;
  bottom: 0;
  background: ${theme.bg.alt};
  color: ${theme.brand.alt};
  z-index: 5;
  width: 100%;
  max-width: 100%;
  align-items: center;  
`

export const Company = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center; 
  text-align: center;
  padding: 1rem;
  margin-bottom: 26px;

  & > a {
    max-width: 200px;
    max-height: 75px;
  }
  
  @media (min-width: 1024px) {
    text-align: inherit;
  }
`

export const Address = styled.ul`
  margin: 0;
  padding: 0;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: -.022em;
`

export const AddressItem = styled.li`
  list-style: none;
  line-height: 1.47059;
`

export const ContactItem = styled.a`
  display: flex;
  line-height: 1.47059;
  color: ${theme.brand.default};
  text-decoration: none;
  justify-content: center;
  
  @media (min-width: 1024px) {
    justify-content: flex-start;
  }
`

export const Legal = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 20px 0;
  padding: 0;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: -.022em;
  justify-content: center;
`

export const LegalLabel = styled.label`
  font-weight: 600;
  font-size: 1.25rem;
  color: ${theme.brand.alt};
  text-align: center;
  padding: 1rem;
`

export const LegalItem = styled.li`
  list-style: none;
  justify-content: center;
`

export const LegalLink = styled(Link)`
  display: flex;
  line-height: 1.47059;
  color: ${theme.brand.default};
  text-decoration: none;
  padding: .2rem;
  justify-content: center;
`

export const LanguageLabel = styled.label`
  font-size: .6rem;
  color: ${theme.text.placeholder};
  opacity: .8;
  padding: .6rem; 
  text-decoration: none;
`

export const LanguageSwitcher = styled.ul`
  display: flex;
  background: ${theme.bg.default};
  border-top: 1px solid ${theme.bg.border};
  align-items: center;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  justify-content: center;
`

export const LanguageItem = styled(Link)`
  font-size: .75rem;
  padding: .6rem; 
  color: ${theme.brand.alt};
  text-decoration: none;
`

export const CopyrightContainer = styled.div`
  display: inline-flex;
  width: 100%;
  max-width: 100%;
  background: ${theme.bg.reverse};
  justify-content: flex-end;
`

export const Copyright = styled.p`
  padding: 1rem;
  font-size: .6rem;
  color: ${theme.brand.alt};
`

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
 
  @media (min-width: 1024px) {
    flex-direction: row;
    max-width: 1240px;
    width: 100%;
    
    & > * {
      flex: 1 50%;
    }
  }
`
